import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const TrafficTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith('/admin')) return;
    let payload;
    try {
      let visitor = localStorage.getItem('gv_analytics_visitor');
      if (!visitor) { visitor = crypto.randomUUID(); localStorage.setItem('gv_analytics_visitor', visitor); }
      let visit = JSON.parse(localStorage.getItem('gv_analytics_visit') || 'null');
      if (!visit?.id || Date.now() - visit.last > 30 * 60 * 1000) visit = { id: crypto.randomUUID() };
      visit.last = Date.now(); localStorage.setItem('gv_analytics_visit', JSON.stringify(visit));
      payload = { event_id: crypto.randomUUID(), visitor_id: visitor, visit_id: visit.id, path: pathname, referrer: document.referrer };
    } catch { return; } // No fingerprint fallback when browser storage is unavailable.
    const timer = setTimeout(() => fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/visit`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), keepalive: true }).catch(() => {}), 150);
    return () => clearTimeout(timer);
  }, [pathname]);
  return null;
};